module.exports = __webpack_public_path__ + "img/extended.71d3f614.png";